import React, { useState } from "react";
import { Box, Flex, Heading, Text, Button } from "@chakra-ui/react";
import { ChevronIcon } from "./icons";

interface ExpandableSectionProps {
  title: string;
  content: React.ReactNode;
}

const ExpandableSection: React.FC<ExpandableSectionProps> = ({
  title,
  content,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Box py={2.5}>
      <Flex justifyContent="space-between" alignItems="center" mb={4} data-testid="pdf-section-header">
        <Heading as="h2" fontSize="2xl" fontWeight="bold" color="gray.800">
          {title}
        </Heading>
        <Button
          onClick={toggleExpand}
          aria-expanded={isExpanded}
          aria-label={isExpanded ? "Collapse section" : "Expand section"}
          variant="unstyled"
          display="flex"
          alignItems="center"
          justifyContent="center"
          minW="auto"
          height="auto"
          padding={0}
          data-testid="collapse"
        >
          <Box 
            as="span" 
            transform={isExpanded ? "rotate(0deg)" : "rotate(180deg)"}
            transition="transform 0.2s"
          >
            <ChevronIcon />
          </Box>
        </Button>
      </Flex>
      {isExpanded && (
        <Text data-testid="pdf-section-content" fontSize="sm" lineHeight="normal" color="gray.800">
          {content}
        </Text>
      )}
    </Box>
  );
};

export default ExpandableSection; 